import i18n from "@/i18n";

export const compareNumbers = (number1: number, number2: number, ascending: boolean): number => {
  const orderModifier = ascending ? 1 : -1;
  return orderModifier * (number1 > number2 ? 1 : -1);
};

export const formatNumber = (value: number): string => Intl.NumberFormat(i18n.global.locale.value).format(value);
export const createArray = (length: number): number[] => [...Array(length).keys()].map((value) => value + 1);
